import { SCREEN_NAME, CLICK_ACTIONS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { clickGiftingBackEvent } from "./GiftingFlow";
import { BaseGiftingPayload } from "@cart-client/interfaces/Coupon";

interface ClickMenuBackOptions {
    basePayload?: BaseGiftingPayload;
    isGiftingCouponListing?: boolean;
    isEmptyCart?: boolean;
}

export const clickMenuBack = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartId?: string,
    groupCartId?: string,
    options?: ClickMenuBackOptions,
): void => {
    if (options?.isGiftingCouponListing) {
        clickGiftingBackEvent(clickEvent, { basePayload: options.basePayload });
    } else {
        clickEvent({
            category: SCREEN_NAME.CHECKOUT,
            action: CLICK_ACTIONS.CLICK_MENU_BACK,
            context: JSON.stringify({ cartId }),
            // eslint-disable-next-line @typescript-eslint/naming-convention
            extraParams: JSON.stringify({
                grpCartId: groupCartId,
                ...(options?.isEmptyCart && { isEmptyCart: options.isEmptyCart }),
            }),
        });
    }
};

export const clickMenuBackDynamic = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: { cartId?: string; deeplink?: string | null; screenName?: string | null },
    groupCartId?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_MENU_BACK_DYNAMIC,
        context: JSON.stringify(context),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};
